import React, { useEffect, useState } from 'react';
import { Download, X } from 'lucide-react';

const DISMISS_KEY = 'qs-install-dismissed-v1';

export default function InstallPrompt() {
  const [deferredEvt, setDeferredEvt] = useState(null);
  const [hidden, setHidden] = useState(() => {
    try { return localStorage.getItem(DISMISS_KEY) === '1'; } catch { return false; }
  });

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredEvt(e);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const install = async () => {
    if (!deferredEvt) return;
    deferredEvt.prompt();
    try {
      await deferredEvt.userChoice;
    } finally {
      setDeferredEvt(null);
    }
  };

  const dismiss = () => {
    setHidden(true);
    try { localStorage.setItem(DISMISS_KEY, '1'); } catch {}
  };

  if (hidden || !deferredEvt) return null;

  return (
    <div
      className="fixed left-3 right-3 bottom-[max(env(safe-area-inset-bottom),0.75rem)] z-50 mx-auto max-w-md rounded-xl bg-slate-900 text-white shadow-2xl border border-slate-700 p-3 flex items-center gap-3 animate-in slide-in-from-bottom-4 duration-300"
      data-testid="pwa-install-banner"
    >
      <Download className="w-5 h-5 shrink-0 text-blue-400" />
      <div className="flex-1 min-w-0 text-sm">
        <div className="font-semibold truncate">Install QuoteSnapp</div>
        <div className="text-slate-300 text-xs">Quote on the go — works offline.</div>
      </div>
      <button
        onClick={install}
        className="px-3 py-1.5 rounded-md bg-blue-600 hover:bg-blue-500 text-white text-xs font-semibold whitespace-nowrap"
        data-testid="pwa-install-accept-btn"
      >
        Install
      </button>
      <button
        onClick={dismiss}
        className="p-1.5 rounded-md hover:bg-white/10"
        aria-label="Dismiss install prompt"
        data-testid="pwa-install-dismiss-btn"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
